<template>
  <!-- 用户管理-用户禁止操作管理-编辑禁止类型 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="编辑禁止类型"
      width="350px"
      @close="closeDialog"
    >
      <el-form
        :model="formData"
        v-if="formData"
        ref="formData"
        label-width="120px"
        size="small"
        :rules="taskRules"
      >
        <el-form-item prop="content" label="限制金额">
           <el-input
            v-model="formData.content"
            placeholder="请输入限制金额"
          ></el-input>
        </el-form-item>
        <el-form-item prop="control_amount" label="流水金额">
           <el-input
            v-model="formData.control_amount"
            placeholder="请输入流水金额"
          ></el-input>
        </el-form-item>
        <el-form-item prop="control_start_time" label="控制开始时间">
           <el-input
            v-model="formData.control_start_time"
            placeholder="请输入控制开始金额"
          ></el-input>
        </el-form-item>
        <el-form-item prop="control_end_time" label="控制结束时间">
           <el-input
            v-model="formData.control_end_time"
            placeholder="请输入控制结束金额"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { patchData, postData, getApiData, patchApiData, postApiData, delApiData } from '@/http'
export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      formData: {//表单数据
        content: 0,//限制金额
        control_amount: 0,//流水金额
        control_start_time: 0,//控制开始时间
        control_end_time: 0,//控制结束时间
      },
      taskRules: {//添加表单验证
        // content: [
        //   {
        //     required: true,
        //     message: '请输入限制金额',
        //     trigger: 'blur'
        //   }
        // ]
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    dialogInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.dialogInfo) {
        //打开弹窗赋值
        this.formData = this.dialogInfo
      }
    }
  },
  created() {
  },
  methods: {
    submit() {
      //保存
      //表单验证后发起请求
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.buttonLoading = true
          let params = this.formData
          patchApiData(`user_forbid/${this.dialogInfo.id}`, params).then(res => {
            if (res) {
              this.$message.success("编辑成功")
              this.closeDialog()//关闭弹窗
              this.$emit("refresh")//刷新数据
            } else {
              this.$message.error("编辑失败")
            }
          }).finally(() => {
            this.buttonLoading = false
          })
        }
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }
}
</script>
<style lang="less" scoped>
</style>